import { render, staticRenderFns } from "./tagType.vue?vue&type=template&id=07a17af8&scoped=true&"
import script from "./tagType.vue?vue&type=script&lang=js&"
export * from "./tagType.vue?vue&type=script&lang=js&"
import style0 from "./tagType.vue?vue&type=style&index=0&id=07a17af8&lang=less&scoped=true&"
import style1 from "./tagType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a17af8",
  null
  
)

export default component.exports